import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'antd';
import { formatNumber, openNotification } from '../../utils';
import CourseCover from '../../assets/course-cover.svg';
import CourseService from '../../services/CourseService';
import { useNavigate } from 'react-router-dom';
import BillingDetailsFields, { InvoiceType } from '../Payments/BillingDetailsFields';

const PaymentModal: React.FC<any> = ({ packageItem, setBuyer }) => {
  const [invoiceType, setInvoiceType] = useState<InvoiceType>('personal');
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const saveFreeCourse = (courseId: any) => {
    setLoading(true);
    CourseService.saveFreeCourse(courseId)
      .then((response: any) => {
        openNotification('success', 'Başarılı', 'Kurs başarıyla eklendi.');
        setTimeout(() => navigate(`/course/${response.data}/detail`), 500);
      })
      .catch(() => openNotification('error', 'Hata', 'Kurs eklenirken hata oluştu.'))
      .finally(() => setLoading(false));
  };

  const handlePaymentSubmit = (values: any) => {
    const postObj: any = {
      name: values.firstName,
      surname: values.lastName,
      billingAddress: values.billingAddress,
      packageId: packageItem.id,
      city: values.city,
      phone: values.phone,
      email: values.email,
    };
    if (invoiceType === 'personal') {
      postObj.identityNumber = values.identityNumber;
    } else {
      postObj.taxNumber = values.taxNumber;
      postObj.taxOffice = values.taxOffice;
      postObj.companyName = values.companyName;
    }
    setBuyer(postObj);
    setVisible(false);
  };

  if (packageItem.free) {
    return <Button className="w-full buy-btn" type="link" size="large" loading={loading} onClick={() => saveFreeCourse(packageItem.id)}>Hemen Başla</Button>;
  }

  return (
    <>
      <Button className="w-full buy-btn" size="large" onClick={() => setVisible(true)}>Hemen Al</Button>
      <Modal visible={visible} onCancel={() => setVisible(false)} width={768} className="payment-modal" footer={null}>
        <Row style={{ marginBottom: 16 }}>
          <Col><img src={CourseCover} alt="Kurs" style={{ height: 120, width: 120, borderRadius: 10 }} /></Col>
          <Col>
            <div style={{ marginLeft: 16 }}>
              <span style={{ display: 'block', fontSize: 24, fontWeight: 700 }}>{packageItem.name}</span>
              <span style={{ fontSize: 36, fontWeight: 700 }}>{formatNumber(packageItem.salePrice)} ₺</span>
            </div>
          </Col>
        </Row>
        <Form form={form} layout="vertical" onFinish={handlePaymentSubmit}>
          <BillingDetailsFields invoiceType={invoiceType} onInvoiceTypeChange={setInvoiceType} />
          <Form.Item>
            <Row justify="end"><Button type="primary" htmlType="submit" size="large">Ödeme Yap</Button></Row>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default PaymentModal;
